// src/components/products/ProductPage.js

import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Products from './Products';

import Logo from '../../images/logo-2.svg'
import Phone from '../../images/telephone.svg'
import LenisSmoothScroll from '../../components/lenissmoothscroll/LenisSmoothScroll';

const ProductPage = () => {
  return (
    <Fragment>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={'Products'} pagesub={'Our Products'} />
      <Products hclass={'services-section-s3'} />
     
      <Footer />
      <Scrollbar />
      < LenisSmoothScroll />
    </Fragment>
  );
};

export default ProductPage;
